// What Add deal made, said at the head of Deals with its Undo (module 10 U285, a-more.html's "Added: <title>, at <stage>,
// yours. n conversations filed under it." with Undo; D62, a week; the Deal work lane's W6). The page goes back to Deals
// opened on the new line, and this line waits there; Deals draws it in the head where the add's button sits.
import { ActionButton } from '../parts/index.js';
import { useEffect, useRef, useState } from 'react';
import { dealWorkApi, DealWorkError } from './api.js';
import { addedNote, noteAdded, type AddedNote } from './addDeal.js';
import './dealwork.css';

/**
 * The line goes when the person closes it, or when Deals is next read (a write on a card, a give, a park), since the
 * page then shows the deal for itself; its Undo stays where it is while the line shows (pipeline FT1, BUGS.md D30: the
 * line never went while Deals stayed open). `read` counts Deals' reads: the read the line was said on is not "next", and
 * nor is the one its own Undo asks for, so "Taken back" is read before it goes.
 */
export function AddedLine({ store, read, onUndone }: { store: string; read: number; onUndone: () => void }) {
  const [note] = useState<AddedNote | null>(() => addedNote(store));
  const [state, setState] = useState<'added' | 'busy' | 'undone' | 'closed'>('added');
  const [wrong, setWrong] = useState<string | null>(null);
  const seen = useRef(read);
  const ownRead = useRef(false);
  // Said once: the next visit to Deals does not say it again (the line holds its own copy for the Undo).
  useEffect(() => { if (note) noteAdded(null); }, [note]);
  useEffect(() => {
    if (read === seen.current) return;
    seen.current = read;
    if (ownRead.current) { ownRead.current = false; return; }
    setState((x) => (x === 'busy' ? x : 'closed'));
  }, [read]);
  if (!note || state === 'closed') return null;
  const a = note.added;
  const undo = () => {
    setState('busy'); setWrong(null);
    dealWorkApi.undoAddDeal(store, a.deals[0]!.dealId, a.actionId)
      .then(() => { setState('undone'); noteAdded(null); ownRead.current = true; onUndone(); })
      .catch((e: unknown) => { setState('added'); setWrong(e instanceof DealWorkError ? e.message : 'Nothing was put back. Try again.'); });
  };
  return (
    <p className={wrong ? 'dwn-note warn dwn-added' : 'dwn-note ok dwn-added'} role="status">
      {state === 'undone'
        ? <>Taken back: {a.deals.length === 1 ? a.deals[0]!.title : `${a.deals.length} deals at ${a.organisationName}`}{a.newCompany ? `, and ${a.organisationName} with ${a.deals.length === 1 ? 'it' : 'them'}` : ''}.</>
        : wrong ?? note.words}
      <span className="dwn-acts">
        {state !== 'undone' ? <ActionButton type="button" className="hx-link" disabled={state === 'busy'} onClick={undo}>Undo</ActionButton> : null}
        <ActionButton reading type="button" className="hx-link" disabled={state === 'busy'} onClick={() => setState('closed')}>Close</ActionButton>
      </span>
    </p>
  );
}
